module.exports = __webpack_public_path__ + "5fdc56a0b7f8e345256f12ecf4b80da8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/assets/onboarding-2.svg
// module id = 1999
// module chunks = 1